import mzr from '../../../assets/mzr.webp'
import mrn from '../../../assets/mrn.webp'
import rznck from '../../../assets/rznck.webp'
import b from '../../../assets/b.webp'
import qn from '../../../assets/qn.webp'
import tylr from '../../../assets/tylr.webp'

export const reviewsData = [
  
  {
    name: "Roberto Reznicek",
    title: "A valuable asset to any organization",
    description: `I'm pleased to recommend Pedro for any future opportunity.
    He demonstrated exceptional interpersonal skills and an impressive ability to work effectively within a team.
    Pedro quickly mastered new skills and technologies, showcasing dedication, a positive attitude, and eagerness to learn.
    He's a valuable asset to any organization and will undoubtedly excel in any role he undertakes.`,
    avatar: rznck,
    role: "Software Development Manager",
  },
  {
    name: "Abe Jr.",
    title: "Strongly recommend!",
    description: `Pedro is one of the most valuable people I have ever worked with.
    He understands complicated issues even when outside of his direct area of expertise.
    He is very thorough in everything he does and can be depended upon to get the job done.
    I would recommend him with any project that requires the very best in it execution.
    I have constantly felt Pedro was one of the very best team mates
    I have ever had the opportunity of working with. Strongly recommend!`,
    avatar: b,
    role: "Head of Product Design",
  },
  {
    name: "Edgardo Moreno",
    title: "A fantastic addition to any team",
    description: `Pedro is the type of team member who actively seeks out answers and tackles new technologies and concepts with determination.
    He learns quickly, supports others, and approaches his work with passion and a hardworking attitude.
    Pedro is a fantastic addition to any team, always bringing positive energy`,
    avatar: mrn,
    role: "Senior Software Engineer",
  },
  {
    name: "Rafael Mazaro",
    title: "High-end quality results",
    description: `Pedro is an excellent software engineer with a great sense of teamwork, partnership, and proactivity.
                  In his day-to-day work, he delivers high-end quality results and is concerned with the broader vision of the product he is working on`,
    avatar: mzr,
    role: "Director of Technology and Strategy",
  },
  {
    name: "Leonardo Aquino",
    title: "Communication and proactivity are strong points",
    description: `Excellent professional with outstanding qualities.
    Communication and proactivity are strong points.
    He is always eager to learn new things and has great reasoning
    skills that help in discussions about important decisions during
    the development process of a tool.`,
    avatar: qn,
    role: "Senior Software Engineer",
  },
  {
    name: "Taylor Byk Schinvelski",
    title: "Consistently proactive",
    description: `A great professional to have on the team, always
    willing to learn and take on new tasks. He is consistently proactive,
    and his speaking and communication skills are among his strengths.`,
    avatar: tylr,
    role: "Senior Software Engineer",
  },
];
